import {
  componentUsageFailure,
  componentUsageRequest,
  componentUsageSuccess
} from './actions';

/**
 * request a component's usage
 * @param {string} componentId - id
 * @returns {undefined}
 */
export const getComponentUsage = componentId => async (dispatch, getState, { api }) => {
  try {
    dispatch(componentUsageRequest(componentId));
    const response = await api.component.getComponentUsageResponse(componentId);
    dispatch(componentUsageSuccess(componentId, response));
  } catch (error) {
    dispatch(componentUsageFailure(componentId, error));
  }
};
